import { useState } from 'react';
import { useTheme } from 'styled-components';
import type { AppManifest } from '@api/apps';
import { presentationOf } from './appPresentation';

export interface AppCover {
  readonly cover: string | null;
  readonly onCoverError: () => void;
}

/** The cover for the current theme, or none once it failed to load. */
export const useAppCover = (manifest: AppManifest): AppCover => {
  const theme = useTheme();
  const [failedCover, setFailedCover] = useState<string | null>(null);
  const { cover, coverLight } = presentationOf(manifest);
  const themedCover = theme.isLightTheme && coverLight ? coverLight : cover;
  const shown = themedCover && themedCover !== failedCover ? themedCover : null;
  return { cover: shown, onCoverError: () => setFailedCover(shown) };
};
